module.exports = __webpack_public_path__ + "static/media/compress-alt.80bca510.svg";